import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { MHLocation } from '../../entities/mh-location.entity';

@Injectable({ providedIn: 'root' })
export abstract class AbstractGeoService {
    public abstract searchByAddress(formattedAddress: string): Observable<MHLocation | null>;

    public abstract searchByGeoLocation(geoLocation: string): Observable<MHLocation | null>;
}
